import { GallerySummary } from '@/features/album/types'
import { SCENE_PRESET_GEOMETRY } from '@/features/gallery-studio-3d/constants'
import { CLASSIC_ROOM_TINT, isLightColor } from '@/features/album/utils/roomColor'

export interface GalleryTint {
  wallColor: string
  floorColor: string
  light: boolean
}

/**
 * Resolves a gallery's real room tint (same fallback chain `GalleryCard`
 * uses): the scene note's saved colors once loaded, else the studio
 * preset's actual defaults, else a neutral classic-room stand-in.
 */
export function resolveGalleryTint(gallery: GallerySummary): GalleryTint {
  const isClassic = gallery.mode === 'classic'
  const geo = SCENE_PRESET_GEOMETRY[gallery.scenePreset || 'corridor']
  const fallback = isClassic ? CLASSIC_ROOM_TINT : geo
  const wallColor = gallery.wallColor || fallback.wallColor
  const floorColor = gallery.floorColor || fallback.floorColor
  return { wallColor, floorColor, light: isLightColor(wallColor) }
}
